module.exports = __webpack_public_path__ + "img/zensocial-logo.png";